/* eslint-disable @next/next/no-img-element */
import clsx from "clsx";
import { ReactNode } from "react";

export default function EmptyState(props: {
  image: string;
  children: ReactNode;
}) {
  return (
    <div className={clsx("flex flex-col items-center w-full sm:w-1/2 lg:max-w-1/5")}>
      <img src={props.image} alt="Glide Logo" width={200} />
      <div>{props.children}</div>
    </div>
  );
}
